export default __webpack_public_path__ + "static/media/proj2_4.f3b88836.jpg";